// EmissaryWorkbench — per-agent wrapper over <CompositionWorkbench> for
// EMISSARY, the client-communication composer.

import CompositionWorkbench from '.';
import { compositionAgentConfig } from './composition-agent-config';
import type { BaseDraft } from '@/data/types';

interface EmissaryWorkbenchProps {
    draft: BaseDraft;
    readOnly?: boolean;
    onApproved?: (draft: BaseDraft) => void;
    onRejected?: (draft: BaseDraft) => void;
    onRevisionRequested?: (draft: BaseDraft) => void;
}

export default function EmissaryWorkbench({
    draft,
    readOnly,
    onApproved,
    onRejected,
    onRevisionRequested,
}: EmissaryWorkbenchProps) {
    return (
        <CompositionWorkbench<BaseDraft>
            agentName="EMISSARY"
            draft={draft}
            table={compositionAgentConfig.EMISSARY.table}
            actions={compositionAgentConfig.EMISSARY.actions}
            readOnly={readOnly}
            onApproved={onApproved}
            onRejected={onRejected}
            onRevisionRequested={onRevisionRequested}
        />
    );
}
